import moment from 'moment'

export const chart = {
  fromMonth: '',
  toMonth: '',
  fromWeek: '',
  toWeek: '',
  year: '',
  week: '',
  type: '',
}

// export const ccfLatestData = {
//   id: '',
//   complaintNo: '',
//   reportedDate: moment().format('YYYY-MM-DD'),
//   customerName: '',
//   productName: '',
//   description: '',
//   transactionStatus: '',
// }

// export const ccfLatestCustomer = {
//   count: 0,
//   name: ''
// }

// export const ccfStatusData = {
//   submitted: '',
//   underValidation: '',
//   underInvestigation: '',
//   cparUnderReview: '',
//   cparSent: '',
//   closed: '',
// }